/**
 * Canonical wizard URL before Richpanel loads.
 * replaceState so the landing-page link is not an extra Back step.
 * No location.replace — that loops Shopify /pages/wizard and /wizard.
 */
(function () {
  var URL_PREFIX = '/wizard';
  var STORAGE_KEY = 'wizard-pet-data';

  var STEP_PATHS = {
    get_started: URL_PREFIX + '/quiz/get-started',
    name: URL_PREFIX + '/quiz/name',
    spayed: URL_PREFIX + '/quiz/spayed',
    age: URL_PREFIX + '/quiz/age',
    breed: URL_PREFIX + '/quiz/breed',
    food: URL_PREFIX + '/quiz/food',
    eating: URL_PREFIX + '/quiz/eating',
    weight: URL_PREFIX + '/quiz/weight',
    composition: URL_PREFIX + '/quiz/composition',
    activity: URL_PREFIX + '/quiz/activity',
    allergies: URL_PREFIX + '/quiz/allergies',
    issues: URL_PREFIX + '/quiz/issues',
    snacks: URL_PREFIX + '/quiz/snacks',
    email: URL_PREFIX + '/quiz/email',
    calculation: URL_PREFIX + '/quiz/calculation',
    lifetime_offer: URL_PREFIX + '/quiz/lifetime-offer',
    box_size: URL_PREFIX + '/plan/box-size',
    flavors: URL_PREFIX + '/plan/flavors',
    plan_overview: URL_PREFIX + '/plan/overview',
    extras: URL_PREFIX + '/plan/extras',
    plan_onetime: URL_PREFIX + '/plan/overview',
    profile: URL_PREFIX + '/profile'
  };

  function getLocalePrefix(pathname) {
    var match = pathname.match(/^(\/[a-z]{2}(-[a-z]{2})?)(?=\/|$)/);
    return match ? match[1] : '';
  }

  function normalizePath(pathname) {
    var localePrefix = getLocalePrefix(pathname);
    var path = localePrefix ? pathname.slice(localePrefix.length) || '/' : pathname;

    if (path.indexOf('/pages/wizard') === 0) {
      path = path.replace('/pages/wizard', '/pages/wizard');
    }
    if (path.indexOf('/pages' + URL_PREFIX) === 0) {
      path = path.replace('/pages' + URL_PREFIX, URL_PREFIX);
    } else if (path === '/pages' + URL_PREFIX) {
      path = URL_PREFIX;
    }

    return { path: path, localePrefix: localePrefix };
  }

  function isKnownStepPath(path) {
    for (var step in STEP_PATHS) {
      if (STEP_PATHS[step] === path) return true;
    }
    return false;
  }

  function getStepFromPath(path) {
    for (var step in STEP_PATHS) {
      if (STEP_PATHS[step] === path) return step;
    }
    return null;
  }

  function isRootUrl(path) {
    if (!getStepFromPath(path)) return true;
    if (path === URL_PREFIX + '/' || path === URL_PREFIX) return true;
    if (path === '/pages/wizard/' || path === '/pages/wizard') return true;
    if (path.indexOf('/quiz/') === -1 && path.indexOf('/plan/') === -1 && path !== URL_PREFIX + '/profile') {
      return true;
    }
    return false;
  }

  function getPathParam() {
    try {
      return new URLSearchParams(window.location.search).get('__path');
    } catch (e) {
      return null;
    }
  }

  function persistedQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('__path');
      var s = params.toString();
      return s ? '?' + s : '';
    } catch (e) {
      return '';
    }
  }

  function readSavedState() {
    var keys = [STORAGE_KEY];
    try {
      var id = new URLSearchParams(window.location.search).get('j') || sessionStorage.getItem('bz_journey_id') || '';
      if (id === 'w5') keys.unshift('wizard-5-pet-data');
      else if (id === 'w3') keys.unshift('wizard-3-pet-data');
    } catch (e) {}
    for (var i = 0; i < keys.length; i += 1) {
      try {
        var raw = localStorage.getItem(keys[i]);
        if (raw) return JSON.parse(raw);
      } catch (e) {}
    }
    return null;
  }

  function hasQuizProgress(saved) {
    if (!saved) return false;
    var pet = saved.petData || {};
    return !!(pet.name || pet.gender || pet.ageGroup || pet.breed ||
      pet.weight != null || saved.petMetaobjectId);
  }

  function journeyId() {
    try {
      return new URLSearchParams(window.location.search).get('j') || sessionStorage.getItem('bz_journey_id') || '';
    } catch (e) {
      return '';
    }
  }

  function journeyEntryStep() {
    return journeyId() === 'w5' ? 'lifetime_offer' : 'name';
  }

  function getStartedAllowed() {
    return journeyId() === 'w3';
  }

  function getResumeStep(saved) {
    if (!saved) return journeyEntryStep();

    var pet = saved.petData || {};
    var hasLoadedData = pet.name || pet.gender || pet.ageGroup || pet.breed ||
      pet.weight != null || saved.customerId;
    if (!hasLoadedData) return journeyEntryStep();

    var step = saved.currentStep || journeyEntryStep();
    if (step === 'plan_snacks') step = 'extras';
    if (step === 'get_started') return journeyEntryStep();
    return STEP_PATHS[step] ? step : journeyEntryStep();
  }

  function needsCanonicalUrl(path, pathParam) {
    if (pathParam) return true;
    return isRootUrl(path);
  }

  function resolveTargetPath(pathParam, saved) {
    if (pathParam === URL_PREFIX + '/plan/onetime') return URL_PREFIX + '/plan/overview';
    if ((pathParam === STEP_PATHS.get_started || pathParam === URL_PREFIX + '/quiz/get-started') && (!getStartedAllowed() || hasQuizProgress(saved))) {
      return STEP_PATHS[getResumeStep(saved)];
    }
    if (pathParam && isKnownStepPath(pathParam)) return pathParam;
    return STEP_PATHS[getResumeStep(saved)];
  }

  var normalized = normalizePath(window.location.pathname);
  var pathParam = getPathParam();
  var savedEarly = readSavedState();

  if (getStepFromPath(normalized.path) === 'get_started' && (!getStartedAllowed() || hasQuizProgress(savedEarly))) {
    var resumePath = STEP_PATHS[getResumeStep(savedEarly)];
    var resumeQuery = persistedQuery();
    var resumeUrl = normalized.localePrefix + resumePath + resumeQuery;
    var resumeCurrent = window.location.pathname + window.location.search + window.location.hash;
    if (resumeCurrent !== resumeUrl) {
      window.history.replaceState({}, '', resumeUrl);
    }
    return;
  }

  if (normalized.path !== URL_PREFIX + '/plan/onetime' && !needsCanonicalUrl(normalized.path, pathParam)) {
    return;
  }

  var saved = savedEarly || readSavedState();
  var targetPath = resolveTargetPath(pathParam, saved);
  if (normalized.path === URL_PREFIX + '/plan/onetime') {
    targetPath = URL_PREFIX + '/plan/overview';
  }
  var query = persistedQuery();
  var hash = window.location.hash || '';
  if (
    normalized.path === URL_PREFIX + '/plan/onetime' ||
    pathParam === URL_PREFIX + '/plan/onetime' ||
    (targetPath === URL_PREFIX + '/plan/overview' && getResumeStep(saved) === 'plan_onetime')
  ) {
    hash = '#onetime';
  } else if (hash === '#onetime' && targetPath !== URL_PREFIX + '/plan/overview') {
    hash = '';
  }
  var targetUrl = normalized.localePrefix + targetPath + query + hash;
  var currentUrl = window.location.pathname + window.location.search + window.location.hash;

  if (currentUrl === targetUrl) return;

  window.history.replaceState({}, '', targetUrl);
})();
